export default {
    Business: 3,
    Budget: 1,
    Other: 2,
}